import { FullScreenSlideSt } from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/FullScreenSlides.css';
import MediaSlide from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/components/FullScreenList/components/MediaSlide/MediaSlide';

const FullScreenList = ({
  items,
  offset,
  onImageSlideClick,
  setIsPlaying,
  isPlaying,
  withBackground,
}) =>
  items.map(({ mediaType, src, type, alt, previewSrc, original }, index) => (
    <FullScreenSlideSt
      key={index}
      offset={offset}
      data-qa={`image-gallery-slide-fs-${index}`}
      onClick={() => onImageSlideClick(index)}
    >
      {offset === index && (
        <MediaSlide
          src={src}
          previewSrc={previewSrc}
          type={type}
          alt={alt}
          original={original}
          mediaType={mediaType}
          index={index}
          offset={offset}
          setIsPlaying={setIsPlaying}
          withBackground={withBackground}
          isPlaying={isPlaying}
        />
      )}
    </FullScreenSlideSt>
  ));

export default FullScreenList;
